module.exports = __webpack_public_path__ + "img/download_2.4f588891.svg";